export default __webpack_public_path__ + "static/media/Joystix-monospace.03fd3941.woff";